import React, { useContext, useEffect, useState } from "react"; // Add useState
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

// alphabetized
import * as yup from "yup";
import qapi from "views_shared/app/javascript/api";
import SaveSpinnerButton from "./save_spinner_button";
import companySchema from "../../../yup_schemas/company_schema";
import { CompanyContext } from "../data/company_context_management";

function FacebookUrlForm() {
  const context = useContext(CompanyContext);

  const { company, isUpdating, setIsUpdating, setDoTopLevelFetch } = context;

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    setError,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(
      yup.object().shape({
        facebook_url: companySchema.fields.facebook_url,
      }),
    ),
  });

  const urlContactInfo = company.contact_details?.find((detail) => detail.type === "facebook") || {};
  const url = urlContactInfo.value;

  // Watch the facebook_url value
  const watchedFacebookUrl = watch("facebook_url");

  // State to manage whether the Save button is enabled
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);

  useEffect(() => {
    setValue("facebook_url", url);
    setIsSaveEnabled(false); // Reset when the component is reloaded
  }, [company, setValue, url]);

  useEffect(() => {
    // Enable the Save button if the watched value is different from the initial value
    setIsSaveEnabled(watchedFacebookUrl !== url);
  }, [watchedFacebookUrl, url]);

  const onSubmit = async (data, event) => {
    event.preventDefault();
    setIsUpdating(true);

    const { facebook_url: facebookUrl } = data;

    let response;

    const contactInfoId = urlContactInfo.contact_info_id;
    if (contactInfoId) {
      if (facebookUrl.length === 0) {
        response = await qapi.contactInfos.deleteById(contactInfoId);
      } else {
        response = await qapi.contactInfos.updateById(contactInfoId, { value: facebookUrl });
      }
    } else {
      response = await qapi.contactInfos.createByContactOwner(company.id, "Id::PromoEntity::Company", {
        value: facebookUrl,
        value_type: "facebook",
      });
    }

    if (response.error) {
      const error = response.error?.body?.errors[0];
      setError("facebook_url", {
        type: "manual",
        message: error?.detail || "An error occurred",
      });
    } else {
      setDoTopLevelFetch(true);
      setIsSaveEnabled(false);
    }

    setIsUpdating(false);
  };

  return (
    // Top-aligned on purpose: centering re-centers the whole row when the validation message
    // appears, visibly shoving the field upward. Top alignment keeps label, field, and Save in
    // place and lets the message extend downward.
    <form onSubmit={(e) => e.preventDefault()} className="row g-2 align-items-start mb-2">
      <label htmlFor="facebook_url" className="col-sm-3 col-form-label">
        Facebook URL
      </label>
      <div className="col">
        <input
          className={`form-control ${errors?.facebook_url ? "is-invalid" : ""}`}
          defaultValue={url}
          id="facebook_url"
          pattern="https://.*"
          placeholder="https://www.facebook.com/example"
          type="url"
          required
          {...register("facebook_url")}
        />
        {errors?.facebook_url && <div className="invalid-feedback">{errors?.facebook_url?.message}</div>}
      </div>
      <div className="col-auto">
        <SaveSpinnerButton
          activeText="Saving..."
          className={`${!isSaveEnabled ? "disabled" : ""}`}
          disabled={!isSaveEnabled}
          id="facebook-url-save"
          inactiveText="Save"
          isSaving={isUpdating}
          onClick={handleSubmit(onSubmit)}
        />
      </div>
    </form>
  );
}

export default FacebookUrlForm;
